
























































































import { Component, Vue } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { DocumentFile } from '@/types/document'
import { DocumentFilePayload } from '@/api/document/types'
import FileInput from '@/components/common/inputs/FileInput.vue'

@Component({
  components: {
    FileInput,
    Loading: () => import('@/components/common/loadings/UploadLoading.vue')
  },
  filters: {
    formatDate(dateString: string) {
      const date = new Date(dateString)
      return date.toLocaleString()
    }
  }
})
export default class DocumentUpload extends Vue {
  $store!: ExStore
  document: DocumentFile | null = null
  base64 = ''
  fileSelect = false
  loading = false

  get patientId() {
    return Number(this.$route.params.patientId)
  }

  get documentId() {
    return Number(this.$route.params.documentId)
  }

  get senderName() {
    if (!this.document) return ''
    const worker = this.document.worker
    return worker ? worker.lastName + worker.firstName : '患者'
  }

  async fetchDocument() {
    try {
      const res = await this.$api.document.fetchOne({
        patientId: this.patientId,
        documentId: this.documentId
      })
      this.document = res
      this.document.fileName = this.document.fileName || ''
      this.document.title = this.document.title || ''
    } catch (e) {
      if (e.message === 'Not Found') {
        this.$router.replace({ name: 'DocumentTabIndex' })
      }
    }
  }

  async upload() {
    this.loading = true
    try {
      const payload: Partial<DocumentFilePayload> = {
        title: this.document?.title,
        fileName: this.document?.fileName,
        isPatientViewable: this.document?.isPatientViewable
      }

      if (this.base64) {
        payload.fileContent = this.base64
      }

      await this.$api.document.patch({
        patientId: this.patientId,
        documentId: this.documentId,
        payload
      })
      this.$router.push({
        name: 'DocumentTabIndex'
      })
      this.loading = false
    } catch (e) {
      console.error(e)
      this.loading = false
    }
  }

  async created() {
    await this.fetchDocument()
  }
}
